import '../style.css';
import Library from '../lib/Library.js';
import {Map} from '../lib/Map.js';
import {BaseLayer} from '../lib/BaseLayer.js';
import {MapLayer} from '../lib/MapLayer.js';
import {RadarsLayer} from '../lib/composite/Radars.js';
import {RadarSiteLayer} from '../lib/layers/RadarSite.js';
import {MousePosition} from '../lib/controls/MousePosition.js';
import {ScaleLine} from '../lib/controls/ScaleLine.js';
import {FullScreen} from '../lib/controls/FullScreen.js';
import {DateLabel} from '../lib/controls/DateLabel.js';

let cur_date = Library.getDate();
console.info( cur_date );

function init(){
    let map = new Map();
    map.addLayer( new BaseLayer( map, {"type": "globe_light"} ))
    map.addLayer( new RadarsLayer( map, {"looping": true, "opacity": 1.} ));
    map.addLayer( new MapLayer( map, {"type": "basic"}, {"visible": true } ));
    map.addLayer( new MapLayer( map, {"type": "county"} ));
    map.addLayer( new MapLayer( map, {"type": "road"} ));
    map.addLayer( new MapLayer( map, {"type": "highway"} ));
    map.addLayer( new MapLayer( map, {"type": "jetroute"} ));
    map.addLayer( new MapLayer( map, {"type": "airway"} ));
    map.addLayer( new MapLayer( map, {"type": "airspace"} ));
    map.addLayer( new MapLayer( map, {"type": "fir"} ));
    map.addLayer( new RadarSiteLayer( map, {"visible": true } ));
    map.addControl( new MousePosition( map ));
    map.addControl( new ScaleLine( map ));
    map.addControl( new FullScreen( map ));
    map.addControl( new DateLabel( map ));
    map.setupInput();
    map.setLocation();
    map.setTimeout();

    window.map = map;
}

document.addEventListener("DOMContentLoaded", function() {
    init();
});
